import { BASE_PATH } from 'utils/constants'

export const useCleanBasePath = (path: string): string => path.replace(BASE_PATH, '/')